import _objectSpread2 from '../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js';
import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js';
import { forwardRef } from 'react';
import { block } from '../../utils/block.js';
import './Input.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const _excluded = ["label", "message", "status", "disabled", "id", "className", "onChange", "value", "icon"];
const b = block('input');
const Input = /*#__PURE__*/forwardRef(function Input(_ref, ref) {
  let {
      label,
      message,
      status,
      disabled = false,
      id,
      className = '',
      onChange,
      value,
      icon
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsxs("div", {
    className: b({
      status,
      disabled
    }).mix(className),
    "aria-label": id,
    id: id,
    children: [/*#__PURE__*/jsx("label", {
      className: b('label'),
      htmlFor: "".concat(id, "-input"),
      children: label
    }), message && /*#__PURE__*/jsx("p", {
      "aria-live": "assertive",
      className: b('message'),
      children: message
    }), /*#__PURE__*/jsxs("div", {
      className: b('input-container'),
      children: [icon && /*#__PURE__*/jsx("div", {
        className: b('icon'),
        children: icon
      }), /*#__PURE__*/jsx("input", _objectSpread2({
        className: b('input', {
          icon: Boolean(icon)
        }),
        disabled: disabled,
        id: "".concat(id, "-input"),
        onChange: onChange,
        "data-status": status,
        ref: ref,
        value: value
      }, rest))]
    })]
  });
});
Input.displayName = 'Input';

export { Input };
